module.exports = __webpack_public_path__ + "img/70.8e44db58.jpg";